export default () => ({
  unreadNoticesCount : 0,
  categories         : []
});
